import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const MagnifierOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.8 11C2.8 8.76743 3.36163 6.72773 4.5703 5.27733C5.73084 3.88468 7.68287 2.8 11 2.8C14.3171 2.8 16.2692 3.88468 17.4297 5.27733C18.6384 6.72773 19.2 8.76743 19.2 11C19.2 13.2326 18.6384 15.2723 17.4297 16.7227C16.2692 18.1153 14.3171 19.2 11 19.2C7.68287 19.2 5.73084 18.1153 4.5703 16.7227C3.36163 15.2723 2.8 13.2326 2.8 11ZM1 11C1 6 3.5 1 11 1C18.5 1 21 6 21 11C21 13.4184 20.4151 15.8369 18.9624 17.6895L22.9964 21.7235L21.7236 22.9963L17.6978 18.9705C16.1417 20.221 13.9604 21 11 21C3.5 21 1 16 1 11Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const MagnifierOutlinedSize24 = hoc(forwardRef(MagnifierOutlinedSize24Component), 'MagnifierOutlinedSize24');

export { MagnifierOutlinedSize24 as default };
//# sourceMappingURL=MagnifierOutlinedSize24.js.map
